$('.accordian-title').click(function(e) {
  	e.preventDefault();
  
    let $this = $(this);
  
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
        $(this).removeClass('active');
    } else {
        $this.parent().parent().find('.accordion-common .accordion__content').removeClass('show');
        $this.parent().parent().find('.accordion-common .accordion__content').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
      
        $this.parent().parent().find('.accordion-common .accordian-title').removeClass('active');
        $(this).toggleClass('active');
    }
});